import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: ()=>import("../views/Home.vue"),
        children:[
            {
                path: '/baseTemplate',
                name: 'baseTemplate',
                component: ()=>import("../views/baseTemplate/Index.vue")
            },
            {
                path: '/extensions',
                name: 'extensions',
                component: ()=>import("../views/extensions/Index.vue")
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: ()=>import("../views/login/Index.vue"),
    }
];

const router = new VueRouter({
    routes
});
export default router
